import { useCallback, useMemo } from 'react';
import { DICTIONARY_STATUS, useLocalization } from '../components/common/LocalizationContext/LocalizationContext';
import { DEFAULT_LANGUAGE_CODE } from '../utils/helpers/defaultLanguage';
import { MISSING_TRANSLATION } from '../utils/helpers/translation';

/**
 * The only supported way to translate in TempEdge.
 * @returns {{tempedgeTranslator: Function, changeLanguage: Function, locale: string, status: string, formatDate: Function}} Translator API.
 * @author armandoricosandoval -ai-
 */
export const useTempEdgeTranslator = () => {
  const localization = useLocalization();
  const locale = localization?.locale || DEFAULT_LANGUAGE_CODE;
  const status = localization?.status || DICTIONARY_STATUS.READY;

  const tempedgeTranslator = useCallback(
    (key, data, defaultMessage) => (localization ? localization.t(key, data, defaultMessage) : defaultMessage || MISSING_TRANSLATION),
    [localization]
  );

  const changeLanguage = useCallback(
    (language) => {
      localization?.setLocale(language);
    },
    [localization]
  );

  const formatDate = useCallback((date) => new Date(date).toLocaleDateString(locale), [locale]);

  return useMemo(
    () => ({ tempedgeTranslator, changeLanguage, locale, status, formatDate }),
    [tempedgeTranslator, changeLanguage, locale, status, formatDate]
  );
};
